import { loyaltyConsentCookieValue } from '../../infrastructure/Configuration'
import AuthService from '../../services/AuthService'
import Currencies from '@/domain/Currencies'
import ExternalStorage from '@/services/ExternalStorage'
import Filter from '../domain/Filter'
import TabTypes from '@/domain/TabTypes'

export default {
  hotel: null,
  nearbyHotels: [],
  loyaltyConsentAccepted: loyaltyConsentCookieValue,
  bookingStayInProgress: null,
  customer: AuthService.currentCustomer(),
  staysHasBeenLoading: false,
  exchangeRates: Currencies.empty(),
  currenciesList: [],
  tripAdvisorHotelInfo: null,
  labelsLoaded: false,
  filter: Filter.empty(),
  filteredHotel: null,
  taxIncludedRegion: ExternalStorage.cookies.taxIncludedRegion(),
  taxExcludedRegion: ExternalStorage.cookies.taxExcludedRegion(),
  isUk: ExternalStorage.cookies.isUk(),
  error: null,
  membersBenefits: null,
  dataQubit: {},
  adults: null,
  children: null,
  guests: null,
  rooms: null,
  occupancy: [],
  checkinDate: null,
  checkoutDate: null,
  toggleGroup: false,
  toggleClass: '',
  nonMemberRate: true,
  tabSelected: TabTypes.MEMBER
}
